import { Cart } from '../../../src/app/models/cart.model';
import { BookingAction, BookingMode, BookingPaymentStatus, BookingType } from '../../../src/app/models/booking.model';
import { ReservationType } from '../../../src/app/models/cart-items/hotel-booking.model';
import { CabinClass, TravelerType, UserTitle } from '../../../src/app/models/cart-items/shared.model';
import {
  AmountQualifier,
  CarClass,
  CarCompany,
  CarTransmissionType,
} from '../../../src/app/models/cart-items/rental-car-booking.model';
import { BookingStatusV2 } from '../../../src/app/models/constants/booking-status.constants';
import { ItineraryPriceGroup } from '../../../src/app/models/cart-items/train-journey-intinerary-segment.model';
import { JourneyDirection } from '../../../src/app/models/cart-items/train-journey.model';

export const mockCartData: Cart = {
  id: 'aae66da1-fc5b-45a1-a30b-6df9541e8d1a',
  customerId: 'd649b842-9bff-4a6e-9e52-20f69a082e85',
  travelReference: 'aae66da',
  actionStates: ['DONE'],
  status: 'COMPLETED',
  tripId: 'DT0151222021',
  tripName: 'Name your trip',
  additionalTripName: null,
  requestApprovalDueDate: null,
  cartApprovers: [],
  startDate: '2021-06-17',
  endDate: '2021-07-14',
  price: {
    totalPriceToPay: 810.78,
    totalPrice: 810.78,
    localTaxes: 0,
    discount: 0,
    currency: 'EUR',
  },
  payments: [
    {
      paymentDate: '2021-05-30',
      orderId: '2b381b87-7503-4bcc-9345-72f8269d58fc',
    },
  ],
  paymentMethod: 'BILLING_PROFILE',
  receiptAvailable: false,
  bids: [],
  ibs: [],
  packages: [],
  gps: [
    {
      id: '7d89bfe3-c3dd-4b55-b2d8-39934a601269',
      requestedCheckIn: '2021-06-18T00:00:00',
      requestedCheckOut: '2021-06-20T00:00:00',
      requestedRooms: [
        {
          requestedRoomId: '2209659b-3a6c-486d-8ab2-d77a98772cf1',
          adults: 1,
          children: 0,
          infants: 0,
          bedType: null,
          roomName: 'Economy Room (No Windows Hobo Sleeper)',
          occupants: [
            {
              id: '2f86ecd7-236f-4959-921a-5611011c0fff',
              userId: 'd649b842-9bff-4a6e-9e52-20f69a082e85',
              firstName: 'John',
              lastName: 'Doe',
              email: 'example.user@example.com',
              phoneNumber: '+38160111222',
              companyName: null,
              emailConfirmation: false,
              costCenterId: '',
              primaryOccupant: true,
              travelerReferenceFields: {},
            },
          ],
        },
      ],
      specialRequests: null,
      locationPreferences: {
        cityName: 'Malmö',
        hotelAddress: 'Baltzarsgatan 20',
      },
      hotelBooker: {
        firstName: 'John',
        lastName: 'Doe',
        email: 'example.user@example.com',
        phoneNumber: '+38160111222',
        companyName: null,
      },
      stars: 4,
      gym: true,
      pool: false,
      breakfast: false,
      requestedCurrency: 'EUR',
      requestedPrice: 148.9,
      localTaxes: {
        currency: null,
        amount: 0,
      },
      bookingAction: BookingAction.NONE,
      bookingStatus: 'COMPLETED',
      type: BookingType.CM_BOOKING,
      cancellationPolicies: [],
      hotelDescription: {
        position: {
          latitude: 55.60456,
          longitude: 13.0038,
        },
        hotelName: 'Hotel Garden',
        address: 'Baltzarsgatan 20',
        phoneNumber: '',
        email: '',
        hotelImage:
          'https://q-xx.bstatic.com/xdata/images/hotel/max500/172263018.jpg' +
          '?k=b9499f8c0c4f1c6f146821c4d293645708b42ee077388700f3b9718cbfd44f1f&o=',
        reservationCodes: [
          {
            reservationCode: '2543101292',
            reservationType: ReservationType.ID,
          },
          {
            reservationCode: '9692',
            reservationType: ReservationType.PIN,
          },
        ],
        moreContentAvailable: false,
        providerName: 'BOOKING_COM',
      },
      paymentStatus: BookingPaymentStatus.COMPLETED,
      corporateRate: false,
      refundable: false,
      prePaid: true,
    },
  ],
  gos: [],
  tickets: [],
  flightBookings: [
    {
      id: '4dc9cf10-5e70-4dcb-8707-faf30d81df03',
      totalPrice: 114.67,
      currency: 'EUR',
      co2EmissionInGrams: 10200000,
      departingFlightDeparture: '2021-06-17T11:10:00',
      departingFlightDuration: 42900,
      arrivingFlightDuration: 42900,
      numberOfStops: 1,
      flights: [
        {
          duration: 42900,
          co2EmissionInGrams: 10200000,
          segments: [
            {
              id: '31347663-e5be-4d97-ace3-69ea6da944fe',
              duration: 9900,
              marketingCarrier: 'DY',
              marketingAirline: {
                code: 'DY',
                name: 'Norwegian',
                iconUrl: 'https://dib-cdn-152731.c.cdn77.org/production/flights/carrierlogos/DY.gif',
              },
              operatingCarrier: 'DY',
              operatingAirline: {
                code: 'DY',
                name: 'Norwegian',
                iconUrl: 'https://dib-cdn-152731.c.cdn77.org/production/flights/carrierlogos/DY.gif',
              },
              flightNumber: '1977',
              aircraftModel: '73H',
              arrival: {
                time: '2021-06-17T13:55:00',
                airportCode: 'OSL',
                airportName: 'Oslo',
                airportCountryCode: 'NO',
                terminal: null,
                flightTaxiOption: false,
              },
              departure: {
                time: '2021-06-17T11:10:00',
                airportCode: 'BEG',
                airportName: 'Belgrade',
                airportCountryCode: 'RS',
                terminal: '2',
                flightTaxiOption: false,
              },
              airportChange: false,
              layover: 14700,
              shortLayover: null,
              longLayover: false,
              differentDay: true,
              cabinClass: CabinClass.ECONOMY,
              baggageAllowance: {
                quantity: null,
                weight: {
                  value: null,
                  unit: null,
                },
              },
            },
            {
              id: 'e018812e-0e85-4c57-b4c4-f2af7abd8610',
              duration: 3600,
              marketingCarrier: 'DY',
              marketingAirline: {
                code: 'DY',
                name: 'Norwegian',
                iconUrl: 'https://dib-cdn-152731.c.cdn77.org/production/flights/carrierlogos/DY.gif',
              },
              operatingCarrier: 'DY',
              operatingAirline: {
                code: 'DY',
                name: 'Norwegian',
                iconUrl: 'https://dib-cdn-152731.c.cdn77.org/production/flights/carrierlogos/DY.gif',
              },
              flightNumber: '822',
              aircraftModel: '73H',
              arrival: {
                time: '2021-06-17T19:00:00',
                airportCode: 'ARN',
                airportName: 'Stockholm Arlanda',
                airportCountryCode: 'SE',
                terminal: '5',
                flightTaxiOption: false,
              },
              departure: {
                time: '2021-06-17T18:00:00',
                airportCode: 'OSL',
                airportName: 'Oslo',
                airportCountryCode: 'NO',
                terminal: null,
                flightTaxiOption: false,
              },
              airportChange: false,
              layover: null,
              shortLayover: null,
              longLayover: false,
              differentDay: true,
              cabinClass: CabinClass.ECONOMY,
              baggageAllowance: {
                quantity: null,
                weight: {
                  value: null,
                  unit: null,
                },
              },
            },
          ],
        },
      ],
      travelers: [
        {
          id: 'be341164-b5b9-48bf-bf46-f86200b2908b',
          userId: 'd649b842-9bff-4a6e-9e52-20f69a082e85',
          title: UserTitle.MR,
          firstName: 'John',
          lastName: 'Doe',
          middleName: null,
          birthday: '1999-02-18',
          loyaltyCardProvider: null,
          loyaltyCardNumber: null,
          email: 'example.user@example.com',
          emailConfirmation: false,
          travelerType: TravelerType.ADULT,
          flightTickets: [
            {
              ticketNo: '328-1103400401',
              segment: [
                {
                  id: '31347663-e5be-4d97-ace3-69ea6da944fe',
                  duration: 9900,
                  marketingCarrier: 'DY',
                  marketingAirline: {
                    code: 'DY',
                    name: 'Norwegian',
                    iconUrl: 'https://dib-cdn-152731.c.cdn77.org/production/flights/carrierlogos/DY.gif',
                  },
                  operatingCarrier: 'DY',
                  operatingAirline: {
                    code: 'DY',
                    name: 'Norwegian',
                    iconUrl: 'https://dib-cdn-152731.c.cdn77.org/production/flights/carrierlogos/DY.gif',
                  },
                  flightNumber: '1977',
                  aircraftModel: '73H',
                  arrival: {
                    time: '2021-06-17T13:55:00',
                    airportCode: 'OSL',
                    airportName: 'Oslo',
                    airportCountryCode: 'NO',
                    terminal: null,
                    flightTaxiOption: false,
                  },
                  departure: {
                    time: '2021-06-17T11:10:00',
                    airportCode: 'BEG',
                    airportName: 'Belgrade',
                    airportCountryCode: 'RS',
                    terminal: '2',
                    flightTaxiOption: false,
                  },
                  airportChange: false,
                  layover: 14700,
                  shortLayover: null,
                  longLayover: false,
                  differentDay: true,
                  cabinClass: CabinClass.ECONOMY,
                  baggageAllowance: {
                    quantity: null,
                    weight: {
                      value: null,
                      unit: null,
                    },
                  },
                },
                {
                  id: 'e018812e-0e85-4c57-b4c4-f2af7abd8610',
                  duration: 3600,
                  marketingCarrier: 'DY',
                  marketingAirline: {
                    code: 'DY',
                    name: 'Norwegian',
                    iconUrl: 'https://dib-cdn-152731.c.cdn77.org/production/flights/carrierlogos/DY.gif',
                  },
                  operatingCarrier: 'DY',
                  operatingAirline: {
                    code: 'DY',
                    name: 'Norwegian',
                    iconUrl: 'https://dib-cdn-152731.c.cdn77.org/production/flights/carrierlogos/DY.gif',
                  },
                  flightNumber: '822',
                  aircraftModel: '73H',
                  arrival: {
                    time: '2021-06-17T19:00:00',
                    airportCode: 'ARN',
                    airportName: 'Stockholm Arlanda',
                    airportCountryCode: 'SE',
                    terminal: '5',
                    flightTaxiOption: false,
                  },
                  departure: {
                    time: '2021-06-17T18:00:00',
                    airportCode: 'OSL',
                    airportName: 'Oslo',
                    airportCountryCode: 'NO',
                    terminal: null,
                    flightTaxiOption: false,
                  },
                  airportChange: false,
                  layover: null,
                  shortLayover: null,
                  longLayover: false,
                  differentDay: true,
                  cabinClass: CabinClass.ECONOMY,
                  baggageAllowance: {
                    quantity: null,
                    weight: {
                      value: null,
                      unit: null,
                    },
                  },
                },
              ],
            },
          ],
          costCenterId: null,
          addons: null,
          exchanged: false,
          travelerReferenceFields: {},
        },
      ],
      bookingReference: {
        reference: 'OF9ABX',
        source: 'Amadeus',
      },
      status: 'COMPLETED',
      action: BookingAction.NONE,
      paymentStatus: BookingPaymentStatus.COMPLETED,
      hasExchange: false,
      exchanged: false,
    },
    {
      id: '6e49f7d7-e9c6-4488-81dc-e922f1031f16',
      totalPrice: 133.7,
      currency: 'EUR',
      co2EmissionInGrams: 8200000,
      departingFlightDeparture: '2021-06-20T10:30:00',
      departingFlightDuration: 182100,
      arrivingFlightDuration: 182100,
      numberOfStops: 1,
      flights: [
        {
          duration: 182100,
          co2EmissionInGrams: 8200000,
          segments: [
            {
              id: '166f60c0-fb74-4c19-a58f-43902fc74aa4',
              duration: 6300,
              marketingCarrier: 'LO',
              marketingAirline: {
                code: 'LO',
                name: 'LOT - Polish Airlines',
                iconUrl: 'https://dib-cdn-152731.c.cdn77.org/production/flights/carrierlogos/LO.gif',
              },
              operatingCarrier: 'LO',
              operatingAirline: {
                code: 'LO',
                name: 'LOT - Polish Airlines',
                iconUrl: 'https://dib-cdn-152731.c.cdn77.org/production/flights/carrierlogos/LO.gif',
              },
              flightNumber: '454',
              aircraftModel: 'E75',
              arrival: {
                time: '2021-06-20T12:15:00',
                airportCode: 'WAW',
                airportName: 'Warsaw',
                airportCountryCode: 'PL',
                terminal: null,
                flightTaxiOption: false,
              },
              departure: {
                time: '2021-06-20T10:30:00',
                airportCode: 'ARN',
                airportName: 'Stockholm Arlanda',
                airportCountryCode: 'SE',
                terminal: '5',
                flightTaxiOption: false,
              },
              airportChange: false,
              layover: 84900,
              shortLayover: null,
              longLayover: false,
              differentDay: true,
              cabinClass: CabinClass.ECONOMY,
              baggageAllowance: {
                quantity: null,
                weight: {
                  value: null,
                  unit: null,
                },
              },
            },
            {
              id: 'e4580d30-3e1c-4bf3-be4d-047146bd9ffa',
              duration: 6000,
              marketingCarrier: 'LO',
              marketingAirline: {
                code: 'LO',
                name: 'LOT - Polish Airlines',
                iconUrl: 'https://dib-cdn-152731.c.cdn77.org/production/flights/carrierlogos/LO.gif',
              },
              operatingCarrier: 'LO',
              operatingAirline: {
                code: 'LO',
                name: 'LOT - Polish Airlines',
                iconUrl: 'https://dib-cdn-152731.c.cdn77.org/production/flights/carrierlogos/LO.gif',
              },
              flightNumber: '571',
              aircraftModel: 'E75',
              arrival: {
                time: '2021-06-21T13:30:00',
                airportCode: 'BEG',
                airportName: 'Belgrade',
                airportCountryCode: 'RS',
                terminal: '2',
                flightTaxiOption: false,
              },
              departure: {
                time: '2021-06-21T11:50:00',
                airportCode: 'WAW',
                airportName: 'Warsaw',
                airportCountryCode: 'PL',
                terminal: null,
                flightTaxiOption: false,
              },
              airportChange: false,
              layover: null,
              shortLayover: null,
              longLayover: false,
              differentDay: true,
              cabinClass: CabinClass.ECONOMY,
              baggageAllowance: {
                quantity: null,
                weight: {
                  value: null,
                  unit: null,
                },
              },
            },
          ],
        },
      ],
      travelers: [
        {
          id: 'ea953607-ccef-40e5-9d54-81ce0e0e74b9',
          userId: 'd649b842-9bff-4a6e-9e52-20f69a082e85',
          title: UserTitle.MR,
          firstName: 'John',
          lastName: 'Doe',
          middleName: null,
          birthday: '1999-02-18',
          loyaltyCardProvider: null,
          loyaltyCardNumber: null,
          email: 'example.user@example.com',
          emailConfirmation: false,
          travelerType: TravelerType.ADULT,
          flightTickets: [
            {
              ticketNo: '080-1966415096',
              segment: [
                {
                  id: '166f60c0-fb74-4c19-a58f-43902fc74aa4',
                  duration: 6300,
                  marketingCarrier: 'LO',
                  marketingAirline: {
                    code: 'LO',
                    name: 'LOT - Polish Airlines',
                    iconUrl: 'https://dib-cdn-152731.c.cdn77.org/production/flights/carrierlogos/LO.gif',
                  },
                  operatingCarrier: 'LO',
                  operatingAirline: {
                    code: 'LO',
                    name: 'LOT - Polish Airlines',
                    iconUrl: 'https://dib-cdn-152731.c.cdn77.org/production/flights/carrierlogos/LO.gif',
                  },
                  flightNumber: '454',
                  aircraftModel: 'E75',
                  arrival: {
                    time: '2021-06-20T12:15:00',
                    airportCode: 'WAW',
                    airportName: 'Warsaw',
                    airportCountryCode: 'PL',
                    terminal: null,
                    flightTaxiOption: false,
                  },
                  departure: {
                    time: '2021-06-20T10:30:00',
                    airportCode: 'ARN',
                    airportName: 'Stockholm Arlanda',
                    airportCountryCode: 'SE',
                    terminal: '5',
                    flightTaxiOption: false,
                  },
                  airportChange: false,
                  layover: 84900,
                  shortLayover: null,
                  longLayover: false,
                  differentDay: true,
                  cabinClass: CabinClass.ECONOMY,
                  baggageAllowance: {
                    quantity: null,
                    weight: {
                      value: null,
                      unit: null,
                    },
                  },
                },
                {
                  id: 'e4580d30-3e1c-4bf3-be4d-047146bd9ffa',
                  duration: 6000,
                  marketingCarrier: 'LO',
                  marketingAirline: {
                    code: 'LO',
                    name: 'LOT - Polish Airlines',
                    iconUrl: 'https://dib-cdn-152731.c.cdn77.org/production/flights/carrierlogos/LO.gif',
                  },
                  operatingCarrier: 'LO',
                  operatingAirline: {
                    code: 'LO',
                    name: 'LOT - Polish Airlines',
                    iconUrl: 'https://dib-cdn-152731.c.cdn77.org/production/flights/carrierlogos/LO.gif',
                  },
                  flightNumber: '571',
                  aircraftModel: 'E75',
                  arrival: {
                    time: '2021-06-21T13:30:00',
                    airportCode: 'BEG',
                    airportName: 'Belgrade',
                    airportCountryCode: 'RS',
                    terminal: '2',
                    flightTaxiOption: false,
                  },
                  departure: {
                    time: '2021-06-21T11:50:00',
                    airportCode: 'WAW',
                    airportName: 'Warsaw',
                    airportCountryCode: 'PL',
                    terminal: null,
                    flightTaxiOption: false,
                  },
                  airportChange: false,
                  layover: null,
                  shortLayover: null,
                  longLayover: false,
                  differentDay: true,
                  cabinClass: CabinClass.ECONOMY,
                  baggageAllowance: {
                    quantity: null,
                    weight: {
                      value: null,
                      unit: null,
                    },
                  },
                },
              ],
            },
          ],
          costCenterId: null,
          addons: null,
          exchanged: false,
          travelerReferenceFields: {},
        },
      ],
      bookingReference: {
        reference: 'OF9KYQ',
        source: 'Amadeus',
      },
      status: 'COMPLETED',
      action: BookingAction.NONE,
      paymentStatus: BookingPaymentStatus.COMPLETED,
      hasExchange: false,
      exchanged: false,
    },
  ],
  taxiBookings: [
    {
      id: '22222-8f25-4379-b90e-6f4d273ca50f',
      status: 'COMPLETED',
      bookingReference: 'FLIGHT-JSG34',
      type: BookingType.TAXI,
      offerId: 'cee5df1e-8f25-4379-b90e-6f4d273ca50f',
      bookingId: '4dc9cf10-5e70-4dcb-8707-faf30d81df03',
      segmentId: 'e018812e-0e85-4c57-b4c4-f2af7abd8610',
      start: {
        datetime: '2021-09-20T06:30:00',
        locationCode: null,
        address: '181 32 Lidingö',
        city: 'Herrljunga',
        zip: '52432',
        country: 'SE',
        lat: 58.0770692,
        lon: 13.0058573,
      },
      end: {
        datetime: '2021-09-20T06:30:00',
        locationCode: 'ARN',
        address: 'Arlanda flygplats',
        city: 'STOCKHOLM-ARLANDA',
        zip: '19060',
        country: 'SE',
        lat: 59.6478722222222,
        lon: 17.9259027777778,
      },
      taxiType: 'FLIGHT',
      transferType: 'PRIVATE',
      serviceProvider: {
        name: 'Taxibokning',
        code: 'TXB',
      },
      vehicle: {
        category: 'ST',
        description: 'Regular taxi, with Taxi Falköping',
        seatCount: 3,
        baggageCount: 3,
      },
      travelers: [
        { id: '13213', firstName: 'John', lastName: 'Doe', travelerReferenceFields: {} },
        { id: '13213', firstName: 'Pera', lastName: 'Peric', travelerReferenceFields: {} },
      ],
      cancellationPolicies: [
        {
          // Non-refundable within 60 minutes of pick-up time
          costAmount: 64.32,
          refundAmount: 0,
          refundAmountPerNight: null,
          currency: 'EUR',
          fromDate: '2021-09-20T05:30:00',
          toDate: '2021-09-20T06:30:00',
          used: false,
          fullRefundable: false,
          cancellationFeeDetails: {
            amount: null,
            currency: 'EUR',
            percent: 100,
            numberOfNights: null,
          },
        },
        {
          // Partially refundable up to 60 minutes of pick-up time
          costAmount: 18.53,
          refundAmount: 45.89,
          refundAmountPerNight: null,
          currency: 'EUR',
          fromDate: '2021-09-20T04:30:00',
          toDate: '2021-09-20T05:30:00',
          used: false,
          fullRefundable: false,
          cancellationFeeDetails: {
            amount: null,
            currency: 'EUR',
            percent: 20,
            numberOfNights: null,
          },
        },
        {
          // Free cancellation up to 120 minutes prior to ride
          costAmount: 0,
          refundAmount: 64.32,
          refundAmountPerNight: null,
          currency: 'EUR',
          fromDate: '2020-09-20T06:30:00',
          toDate: '2021-09-20T04:30:00',
          used: false,
          fullRefundable: true,
          cancellationFeeDetails: {
            amount: null,
            currency: 'EUR',
            percent: 0,
            numberOfNights: null,
          },
        },
        {
          // Non-refundable within 60 minutes of pick-up time
          costAmount: 64.32,
          refundAmount: 0,
          refundAmountPerNight: null,
          currency: 'EUR',
          fromDate: '2021-09-20T05:30:00',
          toDate: '2021-09-20T06:30:00',
          used: false,
          fullRefundable: false,
          cancellationFeeDetails: {
            amount: 64.32,
            currency: 'EUR',
            percent: 0,
            numberOfNights: null,
          },
        },
        {
          // Partially refundable up to 60 minutes of pick-up time
          costAmount: 18.53,
          refundAmount: 45.89,
          refundAmountPerNight: null,
          currency: 'EUR',
          fromDate: '2021-09-20T04:30:00',
          toDate: '2021-09-20T05:30:00',
          used: false,
          fullRefundable: false,
          cancellationFeeDetails: {
            amount: 18.53,
            currency: 'EUR',
            percent: null,
            numberOfNights: null,
          },
        },
        {
          // Free cancellation up to 120 minutes prior to ride
          costAmount: 0,
          refundAmount: 64.32,
          refundAmountPerNight: null,
          currency: 'EUR',
          fromDate: '2020-09-20T06:30:00',
          toDate: '2021-09-20T04:30:00',
          used: false,
          fullRefundable: true,
          cancellationFeeDetails: {
            amount: 0,
            currency: 'EUR',
            percent: null,
            numberOfNights: null,
          },
        },
      ],
      price: {
        amount: 1725,
        currency: 'SEK',
      },
      items: [],
    },
    {
      id: '33333-8f25-4379-b90e-6f4d273ca50f',
      status: 'COMPLETED',
      bookingReference: 'FLIGHT-PG54SD',
      type: BookingType.TAXI,
      offerId: '00bc0788-71b5-4774-a124-666d27350f5e',
      bookingId: '6e49f7d7-e9c6-4488-81dc-e922f1031f16',
      segmentId: '166f60c0-fb74-4c19-a58f-43902fc74aa4',
      start: {
        datetime: '2021-09-20T11:35:00',
        locationCode: 'MMX',
        address: null,
        city: 'SVEDALA',
        zip: '23391',
        country: 'SE',
        lat: 55.5404,
        lon: 13.3642,
      },
      end: {
        datetime: '2021-09-20T11:35:00',
        locationCode: null,
        address: 'Tornfalksgatan Malmö',
        city: 'Malmö',
        zip: 'undefined',
        country: 'SE',
        lat: 55.5676661,
        lon: 13.0121061,
      },
      taxiType: 'FLIGHT',
      transferType: 'PRIVATE',
      serviceProvider: {
        name: 'Taxibokning',
        code: 'TXB',
      },
      vehicle: {
        category: 'ST',
        description: 'Regular taxi, with Vellinge Taxi',
        seatCount: 3,
        baggageCount: 3,
      },
      travelers: [{ id: '13213', firstName: 'John', lastName: 'Doe', travelerReferenceFields: {} }],
      cancellationPolicies: [
        {
          // Non-refundable within 60 minutes of pick-up time
          costAmount: 64.32,
          refundAmount: 0,
          refundAmountPerNight: null,
          currency: 'EUR',
          fromDate: '2021-09-20T10:35:00',
          toDate: '2021-09-20T11:35:00',
          used: false,
          fullRefundable: false,
          cancellationFeeDetails: {
            amount: null,
            currency: 'EUR',
            percent: 100,
            numberOfNights: null,
          },
        },
        {
          // Partially refundable up to 60 minutes of pick-up time
          costAmount: 18.53,
          refundAmount: 45.89,
          refundAmountPerNight: null,
          currency: 'EUR',
          fromDate: '2021-09-20T09:35:00',
          toDate: '2021-09-20T10:35:00',
          used: false,
          fullRefundable: false,
          cancellationFeeDetails: {
            amount: null,
            currency: 'EUR',
            percent: 20,
            numberOfNights: null,
          },
        },
        {
          // Free cancellation up to 120 minutes prior to ride
          costAmount: 0,
          refundAmount: 64.32,
          refundAmountPerNight: null,
          currency: 'EUR',
          fromDate: '2020-09-20T11:35:00',
          toDate: '2021-09-20T09:35:00',
          used: false,
          fullRefundable: true,
          cancellationFeeDetails: {
            amount: null,
            currency: 'EUR',
            percent: 0,
            numberOfNights: null,
          },
        },
        {
          // Non-refundable within 60 minutes of pick-up time
          costAmount: 64.32,
          refundAmount: 0,
          refundAmountPerNight: null,
          currency: 'EUR',
          fromDate: '2021-09-20T10:35:00',
          toDate: '2021-09-20T11:35:00',
          used: false,
          fullRefundable: false,
          cancellationFeeDetails: {
            amount: 64.32,
            currency: 'EUR',
            percent: 0,
            numberOfNights: null,
          },
        },
        {
          // Partially refundable up to 60 minutes of pick-up time
          costAmount: 18.53,
          refundAmount: 45.89,
          refundAmountPerNight: null,
          currency: 'EUR',
          fromDate: '2021-09-20T09:35:00',
          toDate: '2021-09-20T10:35:00',
          used: false,
          fullRefundable: false,
          cancellationFeeDetails: {
            amount: 18.53,
            currency: 'EUR',
            percent: null,
            numberOfNights: null,
          },
        },
        {
          // Free cancellation up to 120 minutes prior to ride
          costAmount: 0,
          refundAmount: 64.32,
          refundAmountPerNight: null,
          currency: 'EUR',
          fromDate: '2020-09-20T11:35:00',
          toDate: '2021-09-20T09:35:00',
          used: false,
          fullRefundable: true,
          cancellationFeeDetails: {
            amount: 0,
            currency: 'EUR',
            percent: null,
            numberOfNights: null,
          },
        },
      ],
      price: {
        amount: 598,
        currency: 'SEK',
      },
      items: [],
    },
    {
      id: '4444-8f25-4379-b90e-6f4d273ca50f',
      status: 'COMPLETED',
      bookingReference: 'TRAIN-JSG34',
      type: BookingType.TAXI,
      offerId: 'asd958ajf-8f25-4379-b90e-6f4d273ca50f',
      bookingId: '98cae036-10c7-4420-95f0-2c0aad571b2a',
      segmentId: '1',
      start: {
        datetime: '2021-09-20T06:30:00',
        locationCode: null,
        address: '181 32 Malmo',
        city: 'Malmo',
        zip: '52432',
        country: 'SE',
        lat: 58.0770692,
        lon: 13.0058573,
      },
      end: {
        datetime: '2021-09-20T06:30:00',
        locationCode: 'MMX',
        address: 'Malmo C',
        city: 'Malmo',
        zip: '19060',
        country: 'SE',
        lat: 59.6478722222222,
        lon: 17.9259027777778,
      },
      taxiType: 'TRAIN',
      transferType: 'PRIVATE',
      serviceProvider: {
        name: 'Taxibokning',
        code: 'TXB',
      },
      vehicle: {
        category: 'ST',
        description: 'Regular taxi, with Taxi Falköping',
        seatCount: 3,
        baggageCount: 3,
      },
      travelers: [
        { id: '13213', firstName: 'John', lastName: 'Doe', travelerReferenceFields: {} },
        { id: '13213', firstName: 'Pera', lastName: 'Peric', travelerReferenceFields: {} },
      ],
      cancellationPolicies: [
        {
          // Non-refundable within 60 minutes of pick-up time
          costAmount: 64.32,
          refundAmount: 0,
          refundAmountPerNight: null,
          currency: 'EUR',
          fromDate: '2021-09-20T05:30:00',
          toDate: '2021-09-20T06:30:00',
          used: false,
          fullRefundable: false,
          cancellationFeeDetails: {
            amount: null,
            currency: 'EUR',
            percent: 100,
            numberOfNights: null,
          },
        },
        {
          // Partially refundable up to 60 minutes of pick-up time
          costAmount: 18.53,
          refundAmount: 45.89,
          refundAmountPerNight: null,
          currency: 'EUR',
          fromDate: '2021-09-20T04:30:00',
          toDate: '2021-09-20T05:30:00',
          used: false,
          fullRefundable: false,
          cancellationFeeDetails: {
            amount: null,
            currency: 'EUR',
            percent: 20,
            numberOfNights: null,
          },
        },
        {
          // Free cancellation up to 120 minutes prior to ride
          costAmount: 0,
          refundAmount: 64.32,
          refundAmountPerNight: null,
          currency: 'EUR',
          fromDate: '2020-09-20T06:30:00',
          toDate: '2021-09-20T04:30:00',
          used: false,
          fullRefundable: true,
          cancellationFeeDetails: {
            amount: null,
            currency: 'EUR',
            percent: 0,
            numberOfNights: null,
          },
        },
        {
          // Non-refundable within 60 minutes of pick-up time
          costAmount: 64.32,
          refundAmount: 0,
          refundAmountPerNight: null,
          currency: 'EUR',
          fromDate: '2021-09-20T05:30:00',
          toDate: '2021-09-20T06:30:00',
          used: false,
          fullRefundable: false,
          cancellationFeeDetails: {
            amount: 64.32,
            currency: 'EUR',
            percent: 0,
            numberOfNights: null,
          },
        },
        {
          // Partially refundable up to 60 minutes of pick-up time
          costAmount: 18.53,
          refundAmount: 45.89,
          refundAmountPerNight: null,
          currency: 'EUR',
          fromDate: '2021-09-20T04:30:00',
          toDate: '2021-09-20T05:30:00',
          used: false,
          fullRefundable: false,
          cancellationFeeDetails: {
            amount: 18.53,
            currency: 'EUR',
            percent: null,
            numberOfNights: null,
          },
        },
        {
          // Free cancellation up to 120 minutes prior to ride
          costAmount: 0,
          refundAmount: 64.32,
          refundAmountPerNight: null,
          currency: 'EUR',
          fromDate: '2020-09-20T06:30:00',
          toDate: '2021-09-20T04:30:00',
          used: false,
          fullRefundable: true,
          cancellationFeeDetails: {
            amount: 0,
            currency: 'EUR',
            percent: null,
            numberOfNights: null,
          },
        },
      ],
      price: {
        amount: 459,
        currency: 'SEK',
      },
      items: [],
    },
  ],
  genericProducts: [],
  trainBookings: [
    {
      id: '98cae036-10c7-4420-95f0-2c0aad571b2a',
      preOrderId: '60b360f54b8882280e6f055e',
      status: BookingStatusV2.COMPLETION,
      bookingReference: 'QVF0533H',
      booker: {
        firstName: 'John',
        lastName: 'Doe',
        email: 'example.user@example.com',
        phoneNumber: '+38160111222',
      },
      rebookable: true,
      refundable: false,
      dynamicCancellationPolicy: true,
      cancelable: true,
      travellers: [
        {
          id: '52013bdd-3db2-4117-9273-4938e575db01',
          travellerNumber: 1,
          firstName: 'John',
          lastName: 'Doe',
          email: 'example.user@example.com',
          phoneNumber: '+38160111222',
          optionSelections: [],
          seatingSelections: [
            {
              journeyId: 965464581,
              itineraryId: 1,
              segmentId: '1',
              description: 'Carriage: 11, Seat: 116, Window, Open coach',
              carriage: '11',
              seat: '116',
              placementOrientation: 'Window',
              placementCharacteristics: 'Open coach',
            },
          ],
          addons: [],
          userId: 'd649b842-9bff-4a6e-9e52-20f69a082e85',
          travelerReferenceFields: {},
        },
      ],
      journeys: [
        {
          journeyAdviceId: 965464581,
          direction: JourneyDirection.IN,
          itineraries: [
            {
              itineraryId: 1,
              priceGroupType: ItineraryPriceGroup.SEAT,
              segments: [
                {
                  segmentId: '1',
                  uniqueSegmentId: 'ec9636cd-a8fc-4cef-9d0a-ae9af9ef0640',
                  transportInformation: {
                    known: [
                      {
                        code: '69',
                        description: 'Restaurant',
                        category: 'FOOD',
                      },
                    ],
                    unknown: [
                      {
                        code: '4',
                        description: 'Standard class only',
                      },
                    ],
                  },
                  departureDateTime: '2021-07-14T16:11:00',
                  departureLocationName: 'Malmö C',
                  departureLocationNameLong: 'Malmö Centralstation',
                  departureTaxiOption: true,
                  departureStationCode: 'MLMC',
                  arrivalDateTime: '2021-07-14T21:12:00',
                  arrivalLocationName: 'Sthlm Central',
                  arrivalLocationNameLong: 'Stockholm Centralstation',
                  arrivalTaxiOption: true,
                  arrivalStationCode: 'STH',
                  bookingClass: 'SECOND',
                  travelMethod: 'Train',
                  productCode: 'Other',
                  transportId: '3942',
                  segmentProducer: 'Snälltåget',
                  serviceBrandName: ' ',
                  duration: 301,
                },
              ],
            },
          ],
        },
      ],
      subTotalPrice: {
        currency: 'EUR',
        amount: 103.72,
      },
      bookingMode: BookingMode.ONLINE,
      co2EmissionInGrams: null,
      integrationFee: null,
    },
    {
      id: '96edd4e3-acee-4f01-925c-14a4cbd7ae01',
      preOrderId: '60b360fb0db0415701cc27fc',
      status: BookingStatusV2.COMPLETION,
      bookingReference: 'QVF0532A',
      booker: {
        firstName: 'John',
        lastName: 'Doe',
        email: 'example.user@example.com',
        phoneNumber: '+38160111222',
      },
      rebookable: true,
      refundable: false,
      dynamicCancellationPolicy: true,
      cancelable: true,
      travellers: [
        {
          id: 'cc7b9c35-4b12-4d8a-b8af-c7c21f401d7a',
          travellerNumber: 1,
          firstName: 'John',
          lastName: 'Doe',
          email: 'example.user@example.com',
          phoneNumber: '+38160111222',
          optionSelections: [],
          seatingSelections: [
            {
              journeyId: 1902639939,
              itineraryId: 1,
              segmentId: '1',
              description: 'Carriage: 11, Seat: 48, Window, Open coach',
              carriage: '11',
              seat: '48',
              placementOrientation: 'Window',
              placementCharacteristics: 'Open coach',
            },
          ],
          addons: [],
          userId: 'd649b842-9bff-4a6e-9e52-20f69a082e85',
          travelerReferenceFields: {},
        },
      ],
      journeys: [
        {
          journeyAdviceId: 1902639939,
          direction: JourneyDirection.OUT,
          itineraries: [
            {
              itineraryId: 1,
              priceGroupType: ItineraryPriceGroup.SEAT,
              segments: [
                {
                  segmentId: '1',
                  uniqueSegmentId: 'ec9636cd-a8fc-4cef-9d0a-ae9af9ef0640',
                  transportInformation: {
                    known: [
                      {
                        code: '69',
                        description: 'Restaurant',
                        category: 'FOOD',
                      },
                    ],
                    unknown: [
                      {
                        code: '4',
                        description: 'Standard class only',
                      },
                    ],
                  },
                  departureDateTime: '2021-07-10T16:22:00',
                  departureLocationName: 'Sthlm Central',
                  departureLocationNameLong: 'Stockholm Centralstation',
                  departureTaxiOption: true,
                  departureStationCode: 'STH',
                  arrivalDateTime: '2021-07-10T21:21:00',
                  arrivalLocationName: 'Malmö C',
                  arrivalLocationNameLong: 'Malmö Centralstation',
                  arrivalTaxiOption: true,
                  arrivalStationCode: 'MLMC',
                  bookingClass: 'SECOND',
                  travelMethod: 'Train',
                  productCode: 'Other',
                  transportId: '3943',
                  segmentProducer: 'Snälltåget',
                  serviceBrandName: ' ',
                  duration: 299,
                },
              ],
            },
          ],
        },
      ],
      subTotalPrice: {
        currency: 'EUR',
        amount: 103.72,
      },
      bookingMode: BookingMode.ONLINE,
      co2EmissionInGrams: null,
      integrationFee: null,
    },
  ],
  rentalCarBookings: [
    {
      id: '680d6817-4c4e-4fd7-abda-7a6b07beef09',
      status: BookingStatusV2.COMPLETION,
      vehicle: {
        model: 'Toyota Yaris',
        category: CarClass.ECONOMY,
        type: null,
        transmission: CarTransmissionType.MANUAL,
        driveType: null,
        fuelAndDistance: null,
        airConditioner: true,
        typeCode: 'ECMR',
        information: {
          passengerCapacity: 5,
          doorNumber: 5,
          bootSize: 3,
        },
      },
      carAgency: {
        code: 'ZE',
        name: CarCompany.HERTZ,
        termsAndConditions: null,
        cancellation: {
          policy: null,
          ratePolicy: null,
          fee: null,
          policyKey: 'untilPickUpTime',
          ratePolicyKey: 'cancellationDetails',
        },
      },
      pickup: {
        dateAndTime: '2021-06-18T10:00:00',
        latitude: 59.65,
        longitude: 17.91667,
        significance: null,
        unit: null,
        value: null,
        address: {
          street: 'Benstocksvagen 1',
          city: 'Stockholm',
          code: '1A',
          name: 'STOT52',
          countryCode: null,
        },
      },
      dropOff: {
        dateAndTime: '2021-06-21T10:00:00',
        latitude: 59.65,
        longitude: 17.91667,
        significance: null,
        unit: null,
        value: null,
        address: {
          street: 'Benstocksvagen 1',
          city: 'Stockholm',
          code: '1A',
          name: 'STOT52',
          countryCode: null,
        },
      },
      offerPriceInfo: [
        {
          ratePrice: {
            identifier: null,
            pnrIdentifier: 'OF9PY2',
            agencyIdentifier: 'J778B732370',
            amount: 198.39,
            currency: 'EUR',
            type: null,
            amountQualifier: null,
            code: null,
            planIndicator: null,
          },
          mileagePolicy: {
            type: 'Km',
            qualifier: 'UNL',
            quantity: null,
            period: 'per rental',
          },
          associatedCharges: [
            {
              chargeType: 'EQUIPMENT',
              unitPrice: 35.58,
              quantity: 1,
              amount: 35.58,
              chargeCode: 'CST',
              freeText: 'CHILD SEAT FOR TODDLER',
              amountQualifier: AmountQualifier.OPTIONAL,
            },
            {
              chargeType: 'EQUIPMENT',
              unitPrice: 17.79,
              quantity: 1,
              amount: 17.79,
              chargeCode: 'CBS',
              freeText: 'CHILD BOOSTER SEAT',
              amountQualifier: AmountQualifier.OPTIONAL,
            },
          ],
        },
      ],
      driver: {
        userId: 'd649b842-9bff-4a6e-9e52-20f69a082e85',
        firstName: 'John',
        lastName: 'Doe',
        email: 'example.user@example.com',
        title: UserTitle.MR,
        phoneNumber: null,
        dateOfBirth: '1999-02-18',
        travelerReferenceFields: {},
      },
      onlyBookerConfirmation: false,
    },
  ],
  labels: [],
  outOfPolicyChecker: {
    customerNeedsApproval: false,
    hotelPolicyCheckers: [],
    flightPolicyCheckers: [],
    trainPolicyCheckers: [],
    outOfPolicy: false,
  },
  createdById: 'd649b842-9bff-4a6e-9e52-20f69a082e85',
  createdByType: 'CUSTOMER',
  createdAt: '2021-05-30T09:51:56',
  yourReference: null,
  currentOrder: {
    id: '2b381b87-7503-4bcc-9345-72f8269d58fc',
    customerId: 'd649b842-9bff-4a6e-9e52-20f69a082e85',
    travelReference: '2b381b8',
    status: 'COMPLETED',
    tripId: 'DT0151222021-001',
    requestApprovalDueDate: null,
    price: {
      totalPriceToPay: 810.78,
      totalPrice: 810.78,
      localTaxes: 0,
      discount: 0,
      currency: 'EUR',
    },
    paymentMethod: 'BILLING_PROFILE',
    gps: [
      {
        id: '7d89bfe3-c3dd-4b55-b2d8-39934a601269',
        requestedCheckIn: '2021-06-18T00:00:00',
        requestedCheckOut: '2021-06-20T00:00:00',
        requestedRooms: [
          {
            requestedRoomId: '2209659b-3a6c-486d-8ab2-d77a98772cf1',
            adults: 1,
            children: 0,
            infants: 0,
            bedType: null,
            roomName: 'Economy Room (No Windows Hobo Sleeper)',
            occupants: [
              {
                id: '2f86ecd7-236f-4959-921a-5611011c0fff',
                userId: 'd649b842-9bff-4a6e-9e52-20f69a082e85',
                firstName: 'John',
                lastName: 'Doe',
                email: 'example.user@example.com',
                phoneNumber: '+38160111222',
                companyName: null,
                emailConfirmation: false,
                costCenterId: '',
                primaryOccupant: true,
                travelerReferenceFields: {},
              },
            ],
          },
        ],
        specialRequests: null,
        locationPreferences: {
          cityName: 'Malmö',
          hotelAddress: 'Baltzarsgatan 20',
        },
        hotelBooker: {
          firstName: 'John',
          lastName: 'Doe',
          email: 'example.user@example.com',
          phoneNumber: '+38160111222',
          companyName: null,
        },
        stars: 4,
        gym: true,
        pool: false,
        breakfast: false,
        requestedCurrency: 'EUR',
        requestedPrice: 148.9,
        localTaxes: {
          currency: null,
          amount: 0,
        },
        bookingAction: BookingAction.NONE,
        bookingStatus: 'COMPLETED',
        type: BookingType.CM_BOOKING,
        cancellationPolicies: [],
        hotelDescription: {
          position: {
            latitude: 55.60456,
            longitude: 13.0038,
          },
          hotelName: 'Hotel Garden',
          address: 'Baltzarsgatan 20',
          phoneNumber: '',
          email: '',
          hotelImage:
            'https://q-xx.bstatic.com/xdata/images/hotel/max500/172263018.jpg' +
            '?k=b9499f8c0c4f1c6f146821c4d293645708b42ee077388700f3b9718cbfd44f1f&o=',
          reservationCodes: [
            {
              reservationCode: '2543101292',
              reservationType: ReservationType.ID,
            },
            {
              reservationCode: '9692',
              reservationType: ReservationType.PIN,
            },
          ],
          moreContentAvailable: false,
          providerName: 'BOOKING_COM',
        },
        paymentStatus: BookingPaymentStatus.COMPLETED,
        corporateRate: false,
        refundable: false,
        prePaid: true,
      },
    ],
    flightBookings: [
      {
        id: '4dc9cf10-5e70-4dcb-8707-faf30d81df03',
        totalPrice: 114.67,
        currency: 'EUR',
        co2EmissionInGrams: 10200000,
        departingFlightDeparture: '2021-06-17T11:10:00',
        departingFlightDuration: 42900,
        arrivingFlightDuration: 42900,
        numberOfStops: 1,
        flights: [
          {
            duration: 42900,
            co2EmissionInGrams: 10200000,
            segments: [
              {
                id: '31347663-e5be-4d97-ace3-69ea6da944fe',
                duration: 9900,
                marketingCarrier: 'DY',
                marketingAirline: {
                  code: 'DY',
                  name: 'Norwegian',
                  iconUrl: 'https://dib-cdn-152731.c.cdn77.org/production/flights/carrierlogos/DY.gif',
                },
                operatingCarrier: 'DY',
                operatingAirline: {
                  code: 'DY',
                  name: 'Norwegian',
                  iconUrl: 'https://dib-cdn-152731.c.cdn77.org/production/flights/carrierlogos/DY.gif',
                },
                flightNumber: '1977',
                aircraftModel: '73H',
                arrival: {
                  time: '2021-06-17T13:55:00',
                  airportCode: 'OSL',
                  airportName: 'Oslo',
                  airportCountryCode: 'NO',
                  terminal: null,
                  flightTaxiOption: false,
                },
                departure: {
                  time: '2021-06-17T11:10:00',
                  airportCode: 'BEG',
                  airportName: 'Belgrade',
                  airportCountryCode: 'RS',
                  terminal: '2',
                  flightTaxiOption: false,
                },
                airportChange: false,
                layover: 14700,
                shortLayover: null,
                longLayover: false,
                differentDay: true,
                cabinClass: CabinClass.ECONOMY,
                baggageAllowance: {
                  quantity: null,
                  weight: {
                    value: null,
                    unit: null,
                  },
                },
              },
              {
                id: 'e018812e-0e85-4c57-b4c4-f2af7abd8610',
                duration: 3600,
                marketingCarrier: 'DY',
                marketingAirline: {
                  code: 'DY',
                  name: 'Norwegian',
                  iconUrl: 'https://dib-cdn-152731.c.cdn77.org/production/flights/carrierlogos/DY.gif',
                },
                operatingCarrier: 'DY',
                operatingAirline: {
                  code: 'DY',
                  name: 'Norwegian',
                  iconUrl: 'https://dib-cdn-152731.c.cdn77.org/production/flights/carrierlogos/DY.gif',
                },
                flightNumber: '822',
                aircraftModel: '73H',
                arrival: {
                  time: '2021-06-17T19:00:00',
                  airportCode: 'ARN',
                  airportName: 'Stockholm Arlanda',
                  airportCountryCode: 'SE',
                  terminal: '5',
                  flightTaxiOption: false,
                },
                departure: {
                  time: '2021-06-17T18:00:00',
                  airportCode: 'OSL',
                  airportName: 'Oslo',
                  airportCountryCode: 'NO',
                  terminal: null,
                  flightTaxiOption: false,
                },
                airportChange: false,
                layover: null,
                shortLayover: null,
                longLayover: false,
                differentDay: true,
                cabinClass: CabinClass.ECONOMY,
                baggageAllowance: {
                  quantity: null,
                  weight: {
                    value: null,
                    unit: null,
                  },
                },
              },
            ],
          },
        ],
        travelers: [
          {
            id: 'be341164-b5b9-48bf-bf46-f86200b2908b',
            userId: 'd649b842-9bff-4a6e-9e52-20f69a082e85',
            title: UserTitle.MR,
            firstName: 'John',
            lastName: 'Doe',
            middleName: null,
            birthday: '1999-02-18',
            loyaltyCardProvider: null,
            loyaltyCardNumber: null,
            email: 'example.user@example.com',
            emailConfirmation: false,
            travelerType: TravelerType.ADULT,
            flightTickets: [
              {
                ticketNo: '328-1103400401',
                segment: [
                  {
                    id: '31347663-e5be-4d97-ace3-69ea6da944fe',
                    duration: 9900,
                    marketingCarrier: 'DY',
                    marketingAirline: {
                      code: 'DY',
                      name: 'Norwegian',
                      iconUrl: 'https://dib-cdn-152731.c.cdn77.org/production/flights/carrierlogos/DY.gif',
                    },
                    operatingCarrier: 'DY',
                    operatingAirline: {
                      code: 'DY',
                      name: 'Norwegian',
                      iconUrl: 'https://dib-cdn-152731.c.cdn77.org/production/flights/carrierlogos/DY.gif',
                    },
                    flightNumber: '1977',
                    aircraftModel: '73H',
                    arrival: {
                      time: '2021-06-17T13:55:00',
                      airportCode: 'OSL',
                      airportName: 'Oslo',
                      airportCountryCode: 'NO',
                      terminal: null,
                      flightTaxiOption: false,
                    },
                    departure: {
                      time: '2021-06-17T11:10:00',
                      airportCode: 'BEG',
                      airportName: 'Belgrade',
                      airportCountryCode: 'RS',
                      terminal: '2',
                      flightTaxiOption: false,
                    },
                    airportChange: false,
                    layover: 14700,
                    shortLayover: null,
                    longLayover: false,
                    differentDay: true,
                    cabinClass: CabinClass.ECONOMY,
                    baggageAllowance: {
                      quantity: null,
                      weight: {
                        value: null,
                        unit: null,
                      },
                    },
                  },
                  {
                    id: 'e018812e-0e85-4c57-b4c4-f2af7abd8610',
                    duration: 3600,
                    marketingCarrier: 'DY',
                    marketingAirline: {
                      code: 'DY',
                      name: 'Norwegian',
                      iconUrl: 'https://dib-cdn-152731.c.cdn77.org/production/flights/carrierlogos/DY.gif',
                    },
                    operatingCarrier: 'DY',
                    operatingAirline: {
                      code: 'DY',
                      name: 'Norwegian',
                      iconUrl: 'https://dib-cdn-152731.c.cdn77.org/production/flights/carrierlogos/DY.gif',
                    },
                    flightNumber: '822',
                    aircraftModel: '73H',
                    arrival: {
                      time: '2021-06-17T19:00:00',
                      airportCode: 'ARN',
                      airportName: 'Stockholm Arlanda',
                      airportCountryCode: 'SE',
                      terminal: '5',
                      flightTaxiOption: false,
                    },
                    departure: {
                      time: '2021-06-17T18:00:00',
                      airportCode: 'OSL',
                      airportName: 'Oslo',
                      airportCountryCode: 'NO',
                      terminal: null,
                      flightTaxiOption: false,
                    },
                    airportChange: false,
                    layover: null,
                    shortLayover: null,
                    longLayover: false,
                    differentDay: true,
                    cabinClass: CabinClass.ECONOMY,
                    baggageAllowance: {
                      quantity: null,
                      weight: {
                        value: null,
                        unit: null,
                      },
                    },
                  },
                ],
              },
            ],
            costCenterId: null,
            addons: null,
            exchanged: false,
            travelerReferenceFields: {},
          },
        ],
        bookingReference: {
          reference: 'OF9ABX',
          source: 'Amadeus',
        },
        status: 'COMPLETED',
        action: BookingAction.NONE,
        paymentStatus: BookingPaymentStatus.COMPLETED,
        hasExchange: false,
        exchanged: false,
      },
      {
        id: '6e49f7d7-e9c6-4488-81dc-e922f1031f16',
        totalPrice: 133.7,
        currency: 'EUR',
        co2EmissionInGrams: 10200000,
        departingFlightDeparture: '2021-06-20T10:30:00',
        departingFlightDuration: 182100,
        arrivingFlightDuration: 182100,
        numberOfStops: 1,
        flights: [
          {
            duration: 182100,
            co2EmissionInGrams: 10200000,
            segments: [
              {
                id: '166f60c0-fb74-4c19-a58f-43902fc74aa4',
                duration: 6300,
                marketingCarrier: 'LO',
                marketingAirline: {
                  code: 'LO',
                  name: 'LOT - Polish Airlines',
                  iconUrl: 'https://dib-cdn-152731.c.cdn77.org/production/flights/carrierlogos/LO.gif',
                },
                operatingCarrier: 'LO',
                operatingAirline: {
                  code: 'LO',
                  name: 'LOT - Polish Airlines',
                  iconUrl: 'https://dib-cdn-152731.c.cdn77.org/production/flights/carrierlogos/LO.gif',
                },
                flightNumber: '454',
                aircraftModel: 'E75',
                arrival: {
                  time: '2021-06-20T12:15:00',
                  airportCode: 'WAW',
                  airportName: 'Warsaw',
                  airportCountryCode: 'PL',
                  terminal: null,
                  flightTaxiOption: false,
                },
                departure: {
                  time: '2021-06-20T10:30:00',
                  airportCode: 'ARN',
                  airportName: 'Stockholm Arlanda',
                  airportCountryCode: 'SE',
                  terminal: '5',
                  flightTaxiOption: false,
                },
                airportChange: false,
                layover: 84900,
                shortLayover: null,
                longLayover: false,
                differentDay: true,
                cabinClass: CabinClass.ECONOMY,
                baggageAllowance: {
                  quantity: null,
                  weight: {
                    value: null,
                    unit: null,
                  },
                },
              },
              {
                id: 'e4580d30-3e1c-4bf3-be4d-047146bd9ffa',
                duration: 6000,
                marketingCarrier: 'LO',
                marketingAirline: {
                  code: 'LO',
                  name: 'LOT - Polish Airlines',
                  iconUrl: 'https://dib-cdn-152731.c.cdn77.org/production/flights/carrierlogos/LO.gif',
                },
                operatingCarrier: 'LO',
                operatingAirline: {
                  code: 'LO',
                  name: 'LOT - Polish Airlines',
                  iconUrl: 'https://dib-cdn-152731.c.cdn77.org/production/flights/carrierlogos/LO.gif',
                },
                flightNumber: '571',
                aircraftModel: 'E75',
                arrival: {
                  time: '2021-06-21T13:30:00',
                  airportCode: 'BEG',
                  airportName: 'Belgrade',
                  airportCountryCode: 'RS',
                  terminal: '2',
                  flightTaxiOption: false,
                },
                departure: {
                  time: '2021-06-21T11:50:00',
                  airportCode: 'WAW',
                  airportName: 'Warsaw',
                  airportCountryCode: 'PL',
                  terminal: null,
                  flightTaxiOption: false,
                },
                airportChange: false,
                layover: null,
                shortLayover: null,
                longLayover: false,
                differentDay: true,
                cabinClass: CabinClass.ECONOMY,
                baggageAllowance: {
                  quantity: null,
                  weight: {
                    value: null,
                    unit: null,
                  },
                },
              },
            ],
          },
        ],
        travelers: [
          {
            id: 'ea953607-ccef-40e5-9d54-81ce0e0e74b9',
            userId: 'd649b842-9bff-4a6e-9e52-20f69a082e85',
            title: UserTitle.MR,
            firstName: 'John',
            lastName: 'Doe',
            middleName: null,
            birthday: '1999-02-18',
            loyaltyCardProvider: null,
            loyaltyCardNumber: null,
            email: 'example.user@example.com',
            emailConfirmation: false,
            travelerType: TravelerType.ADULT,
            flightTickets: [
              {
                ticketNo: '080-1966415096',
                segment: [
                  {
                    id: '166f60c0-fb74-4c19-a58f-43902fc74aa4',
                    duration: 6300,
                    marketingCarrier: 'LO',
                    marketingAirline: {
                      code: 'LO',
                      name: 'LOT - Polish Airlines',
                      iconUrl: 'https://dib-cdn-152731.c.cdn77.org/production/flights/carrierlogos/LO.gif',
                    },
                    operatingCarrier: 'LO',
                    operatingAirline: {
                      code: 'LO',
                      name: 'LOT - Polish Airlines',
                      iconUrl: 'https://dib-cdn-152731.c.cdn77.org/production/flights/carrierlogos/LO.gif',
                    },
                    flightNumber: '454',
                    aircraftModel: 'E75',
                    arrival: {
                      time: '2021-06-20T12:15:00',
                      airportCode: 'WAW',
                      airportName: 'Warsaw',
                      airportCountryCode: 'PL',
                      terminal: null,
                      flightTaxiOption: false,
                    },
                    departure: {
                      time: '2021-06-20T10:30:00',
                      airportCode: 'ARN',
                      airportName: 'Stockholm Arlanda',
                      airportCountryCode: 'SE',
                      terminal: '5',
                      flightTaxiOption: false,
                    },
                    airportChange: false,
                    layover: 84900,
                    shortLayover: null,
                    longLayover: false,
                    differentDay: true,
                    cabinClass: CabinClass.ECONOMY,
                    baggageAllowance: {
                      quantity: null,
                      weight: {
                        value: null,
                        unit: null,
                      },
                    },
                  },
                  {
                    id: 'e4580d30-3e1c-4bf3-be4d-047146bd9ffa',
                    duration: 6000,
                    marketingCarrier: 'LO',
                    marketingAirline: {
                      code: 'LO',
                      name: 'LOT - Polish Airlines',
                      iconUrl: 'https://dib-cdn-152731.c.cdn77.org/production/flights/carrierlogos/LO.gif',
                    },
                    operatingCarrier: 'LO',
                    operatingAirline: {
                      code: 'LO',
                      name: 'LOT - Polish Airlines',
                      iconUrl: 'https://dib-cdn-152731.c.cdn77.org/production/flights/carrierlogos/LO.gif',
                    },
                    flightNumber: '571',
                    aircraftModel: 'E75',
                    arrival: {
                      time: '2021-06-21T13:30:00',
                      airportCode: 'BEG',
                      airportName: 'Belgrade',
                      airportCountryCode: 'RS',
                      terminal: '2',
                      flightTaxiOption: false,
                    },
                    departure: {
                      time: '2021-06-21T11:50:00',
                      airportCode: 'WAW',
                      airportName: 'Warsaw',
                      airportCountryCode: 'PL',
                      terminal: null,
                      flightTaxiOption: false,
                    },
                    airportChange: false,
                    layover: null,
                    shortLayover: null,
                    longLayover: false,
                    differentDay: true,
                    cabinClass: CabinClass.ECONOMY,
                    baggageAllowance: {
                      quantity: null,
                      weight: {
                        value: null,
                        unit: null,
                      },
                    },
                  },
                ],
              },
            ],
            costCenterId: null,
            addons: null,
            exchanged: false,
            travelerReferenceFields: {},
          },
        ],
        bookingReference: {
          reference: 'OF9KYQ',
          source: 'Amadeus',
        },
        status: 'COMPLETED',
        action: BookingAction.NONE,
        paymentStatus: BookingPaymentStatus.COMPLETED,
        hasExchange: false,
        exchanged: false,
      },
    ],
    taxiBookings: [
      {
        id: '11111111-8f25-4379-b90e-6f4d273ca50f',
        status: 'COMPLETED',
        bookingReference: 'ASDA234',
        type: BookingType.TAXI,
        offerId: 'cee5df1e-8f25-4379-b90e-6f4d273ca50f',
        bookingId: '4dc9cf10-5e70-4dcb-8707-faf30d81df03',
        segmentId: 'e018812e-0e85-4c57-b4c4-f2af7abd8610',
        start: {
          datetime: '2021-09-20T06:30:00',
          locationCode: null,
          address: '181 32 Lidingö',
          city: 'Herrljunga',
          zip: '52432',
          country: 'SE',
          lat: 58.0770692,
          lon: 13.0058573,
        },
        end: {
          datetime: '2021-09-20T06:30:00',
          locationCode: 'ARN',
          address: 'Arlanda flygplats',
          city: 'STOCKHOLM-ARLANDA',
          zip: '19060',
          country: 'SE',
          lat: 59.6478722222222,
          lon: 17.9259027777778,
        },
        taxiType: 'FLIGHT',
        transferType: 'PRIVATE',
        serviceProvider: {
          name: 'Taxibokning',
          code: 'TXB',
        },
        vehicle: {
          category: 'ST',
          description: 'Regular taxi, with Taxi Falköping',
          seatCount: 3,
          baggageCount: 3,
        },
        travelers: [{ id: '13213', firstName: 'John', lastName: 'Doe', travelerReferenceFields: {} }],
        cancellationPolicies: [
          {
            // Non-refundable within 60 minutes of pick-up time
            costAmount: 64.32,
            refundAmount: 0,
            refundAmountPerNight: null,
            currency: 'EUR',
            fromDate: '2021-09-20T05:30:00',
            toDate: '2021-09-20T06:30:00',
            used: false,
            fullRefundable: false,
            cancellationFeeDetails: {
              amount: null,
              currency: 'EUR',
              percent: 100,
              numberOfNights: null,
            },
          },
          {
            // Partially refundable up to 60 minutes of pick-up time
            costAmount: 18.53,
            refundAmount: 45.89,
            refundAmountPerNight: null,
            currency: 'EUR',
            fromDate: '2021-09-20T04:30:00',
            toDate: '2021-09-20T05:30:00',
            used: false,
            fullRefundable: false,
            cancellationFeeDetails: {
              amount: null,
              currency: 'EUR',
              percent: 20,
              numberOfNights: null,
            },
          },
          {
            // Free cancellation up to 120 minutes prior to ride
            costAmount: 0,
            refundAmount: 64.32,
            refundAmountPerNight: null,
            currency: 'EUR',
            fromDate: '2020-09-20T06:30:00',
            toDate: '2021-09-20T04:30:00',
            used: false,
            fullRefundable: true,
            cancellationFeeDetails: {
              amount: null,
              currency: 'EUR',
              percent: 0,
              numberOfNights: null,
            },
          },
          {
            // Non-refundable within 60 minutes of pick-up time
            costAmount: 64.32,
            refundAmount: 0,
            refundAmountPerNight: null,
            currency: 'EUR',
            fromDate: '2021-09-20T05:30:00',
            toDate: '2021-09-20T06:30:00',
            used: false,
            fullRefundable: false,
            cancellationFeeDetails: {
              amount: 64.32,
              currency: 'EUR',
              percent: 0,
              numberOfNights: null,
            },
          },
          {
            // Partially refundable up to 60 minutes of pick-up time
            costAmount: 18.53,
            refundAmount: 45.89,
            refundAmountPerNight: null,
            currency: 'EUR',
            fromDate: '2021-09-20T04:30:00',
            toDate: '2021-09-20T05:30:00',
            used: false,
            fullRefundable: false,
            cancellationFeeDetails: {
              amount: 18.53,
              currency: 'EUR',
              percent: null,
              numberOfNights: null,
            },
          },
          {
            // Free cancellation up to 120 minutes prior to ride
            costAmount: 0,
            refundAmount: 64.32,
            refundAmountPerNight: null,
            currency: 'EUR',
            fromDate: '2020-09-20T06:30:00',
            toDate: '2021-09-20T04:30:00',
            used: false,
            fullRefundable: true,
            cancellationFeeDetails: {
              amount: 0,
              currency: 'EUR',
              percent: null,
              numberOfNights: null,
            },
          },
        ],
        price: {
          amount: 1725,
          currency: 'SEK',
        },
        items: [],
      },
      {
        id: '22222222-8f25-4379-b90e-6f4d273ca50f',
        status: 'COMPLETED',
        bookingReference: 'KHAG87',
        type: BookingType.TAXI,
        offerId: '00bc0788-71b5-4774-a124-666d27350f5e',
        bookingId: '6e49f7d7-e9c6-4488-81dc-e922f1031f16',
        segmentId: '166f60c0-fb74-4c19-a58f-43902fc74aa4',
        start: {
          datetime: '2021-09-20T11:35:00',
          locationCode: 'MMX',
          address: null,
          city: 'SVEDALA',
          zip: '23391',
          country: 'SE',
          lat: 55.5404,
          lon: 13.3642,
        },
        end: {
          datetime: '2021-09-20T11:35:00',
          locationCode: null,
          address: 'Tornfalksgatan Malmö',
          city: 'Malmö',
          zip: 'undefined',
          country: 'SE',
          lat: 55.5676661,
          lon: 13.0121061,
        },
        taxiType: 'FLIGHT',
        transferType: 'PRIVATE',
        serviceProvider: {
          name: 'Taxibokning',
          code: 'TXB',
        },
        vehicle: {
          category: 'ST',
          description: 'Regular taxi, with Vellinge Taxi',
          seatCount: 3,
          baggageCount: 3,
        },
        travelers: [{ id: '13213', firstName: 'John', lastName: 'Doe', travelerReferenceFields: {} }],
        cancellationPolicies: [
          {
            // Non-refundable within 60 minutes of pick-up time
            costAmount: 64.32,
            refundAmount: 0,
            refundAmountPerNight: null,
            currency: 'EUR',
            fromDate: '2021-09-20T10:35:00',
            toDate: '2021-09-20T11:35:00',
            used: false,
            fullRefundable: false,
            cancellationFeeDetails: {
              amount: null,
              currency: 'EUR',
              percent: 100,
              numberOfNights: null,
            },
          },
          {
            // Partially refundable up to 60 minutes of pick-up time
            costAmount: 18.53,
            refundAmount: 45.89,
            refundAmountPerNight: null,
            currency: 'EUR',
            fromDate: '2021-09-20T09:35:00',
            toDate: '2021-09-20T10:35:00',
            used: false,
            fullRefundable: false,
            cancellationFeeDetails: {
              amount: null,
              currency: 'EUR',
              percent: 20,
              numberOfNights: null,
            },
          },
          {
            // Free cancellation up to 120 minutes prior to ride
            costAmount: 0,
            refundAmount: 64.32,
            refundAmountPerNight: null,
            currency: 'EUR',
            fromDate: '2020-09-20T11:35:00',
            toDate: '2021-09-20T09:35:00',
            used: false,
            fullRefundable: true,
            cancellationFeeDetails: {
              amount: null,
              currency: 'EUR',
              percent: 0,
              numberOfNights: null,
            },
          },
          {
            // Non-refundable within 60 minutes of pick-up time
            costAmount: 64.32,
            refundAmount: 0,
            refundAmountPerNight: null,
            currency: 'EUR',
            fromDate: '2021-09-20T10:35:00',
            toDate: '2021-09-20T11:35:00',
            used: false,
            fullRefundable: false,
            cancellationFeeDetails: {
              amount: 64.32,
              currency: 'EUR',
              percent: 0,
              numberOfNights: null,
            },
          },
          {
            // Partially refundable up to 60 minutes of pick-up time
            costAmount: 18.53,
            refundAmount: 45.89,
            refundAmountPerNight: null,
            currency: 'EUR',
            fromDate: '2021-09-20T09:35:00',
            toDate: '2021-09-20T10:35:00',
            used: false,
            fullRefundable: false,
            cancellationFeeDetails: {
              amount: 18.53,
              currency: 'EUR',
              percent: null,
              numberOfNights: null,
            },
          },
          {
            // Free cancellation up to 120 minutes prior to ride
            costAmount: 0,
            refundAmount: 64.32,
            refundAmountPerNight: null,
            currency: 'EUR',
            fromDate: '2020-09-20T11:35:00',
            toDate: '2021-09-20T09:35:00',
            used: false,
            fullRefundable: true,
            cancellationFeeDetails: {
              amount: 0,
              currency: 'EUR',
              percent: null,
              numberOfNights: null,
            },
          },
        ],
        price: {
          amount: 598,
          currency: 'SEK',
        },
        items: [],
      },
    ],
    genericProducts: [],
    trainBookings: [
      {
        id: '98cae036-10c7-4420-95f0-2c0aad571b2a',
        preOrderId: '60b360f54b8882280e6f055e',
        status: BookingStatusV2.COMPLETION,
        bookingReference: 'QVF0533H',
        booker: {
          firstName: 'John',
          lastName: 'Doe',
          email: 'example.user@example.com',
          phoneNumber: '+38160111222',
        },
        rebookable: true,
        refundable: false,
        dynamicCancellationPolicy: true,
        cancelable: true,
        travellers: [
          {
            id: '52013bdd-3db2-4117-9273-4938e575db01',
            travellerNumber: 1,
            firstName: 'John',
            lastName: 'Doe',
            email: 'example.user@example.com',
            phoneNumber: '+38160111222',
            optionSelections: [],
            seatingSelections: [
              {
                journeyId: 965464581,
                itineraryId: 1,
                segmentId: '1',
                description: 'Carriage: 11, Seat: 116, Window, Open coach',
                carriage: '11',
                seat: '116',
                placementOrientation: 'Window',
                placementCharacteristics: 'Open coach',
              },
            ],
            addons: [],
            userId: 'd649b842-9bff-4a6e-9e52-20f69a082e85',
            travelerReferenceFields: {},
          },
        ],
        journeys: [
          {
            journeyAdviceId: 965464581,
            direction: JourneyDirection.IN,
            itineraries: [
              {
                itineraryId: 1,
                priceGroupType: ItineraryPriceGroup.SEAT,
                segments: [
                  {
                    segmentId: '1',
                    uniqueSegmentId: 'ec9636cd-a8fc-4cef-9d0a-ae9af9ef0640',
                    transportInformation: {
                      known: [
                        {
                          code: '69',
                          description: 'Restaurant',
                          category: 'FOOD',
                        },
                      ],
                      unknown: [
                        {
                          code: '4',
                          description: 'Standard class only',
                        },
                      ],
                    },
                    departureDateTime: '2021-07-14T16:11:00',
                    departureLocationName: 'Malmö C',
                    departureLocationNameLong: 'Malmö Centralstation',
                    departureTaxiOption: true,
                    departureStationCode: 'MLMC',
                    arrivalDateTime: '2021-07-14T21:12:00',
                    arrivalLocationName: 'Sthlm Central',
                    arrivalLocationNameLong: 'Stockholm Centralstation',
                    arrivalTaxiOption: true,
                    arrivalStationCode: 'STH',
                    bookingClass: 'SECOND',
                    travelMethod: 'Train',
                    productCode: 'Other',
                    transportId: '3942',
                    segmentProducer: 'Snälltåget',
                    serviceBrandName: ' ',
                    duration: 301,
                  },
                ],
              },
            ],
          },
        ],
        subTotalPrice: {
          currency: 'EUR',
          amount: 103.72,
        },
        bookingMode: BookingMode.ONLINE,
        co2EmissionInGrams: null,
        integrationFee: null,
      },
      {
        id: '96edd4e3-acee-4f01-925c-14a4cbd7ae01',
        preOrderId: '60b360fb0db0415701cc27fc',
        status: BookingStatusV2.COMPLETION,
        bookingReference: 'QVF0532A',
        booker: {
          firstName: 'John',
          lastName: 'Doe',
          email: 'example.user@example.com',
          phoneNumber: '+38160111222',
        },
        rebookable: true,
        refundable: false,
        dynamicCancellationPolicy: true,
        cancelable: true,
        travellers: [
          {
            id: 'cc7b9c35-4b12-4d8a-b8af-c7c21f401d7a',
            travellerNumber: 1,
            firstName: 'John',
            lastName: 'Doe',
            email: 'example.user@example.com',
            phoneNumber: '+38160111222',
            optionSelections: [],
            seatingSelections: [
              {
                journeyId: 1902639939,
                itineraryId: 1,
                segmentId: '1',
                description: 'Carriage: 11, Seat: 48, Window, Open coach',
                carriage: '11',
                seat: '48',
                placementOrientation: 'Window',
                placementCharacteristics: 'Open coach',
              },
            ],
            addons: [],
            userId: 'd649b842-9bff-4a6e-9e52-20f69a082e85',
            travelerReferenceFields: {},
          },
        ],
        journeys: [
          {
            journeyAdviceId: 1902639939,
            direction: JourneyDirection.OUT,
            itineraries: [
              {
                itineraryId: 1,
                priceGroupType: ItineraryPriceGroup.SEAT,
                segments: [
                  {
                    segmentId: '1',
                    uniqueSegmentId: 'ec9636cd-a8fc-4cef-9d0a-ae9af9ef0640',
                    transportInformation: {
                      known: [
                        {
                          code: '69',
                          description: 'Restaurant',
                          category: 'FOOD',
                        },
                      ],
                      unknown: [
                        {
                          code: '4',
                          description: 'Standard class only',
                        },
                      ],
                    },
                    departureDateTime: '2021-07-10T16:22:00',
                    departureLocationName: 'Sthlm Central',
                    departureLocationNameLong: 'Stockholm Centralstation',
                    departureTaxiOption: true,
                    departureStationCode: 'STH',
                    arrivalDateTime: '2021-07-10T21:21:00',
                    arrivalLocationName: 'Malmö C',
                    arrivalLocationNameLong: 'Malmö Centralstation',
                    arrivalTaxiOption: true,
                    arrivalStationCode: 'MLMC',
                    bookingClass: 'SECOND',
                    travelMethod: 'Train',
                    productCode: 'Other',
                    transportId: '3943',
                    segmentProducer: 'Snälltåget',
                    serviceBrandName: ' ',
                    duration: 299,
                  },
                ],
              },
            ],
          },
        ],
        subTotalPrice: {
          currency: 'EUR',
          amount: 103.72,
        },
        bookingMode: BookingMode.ONLINE,
        co2EmissionInGrams: null,
        integrationFee: null,
      },
    ],
    outOfPolicyChecker: {
      customerNeedsApproval: false,
      hotelPolicyCheckers: [],
      flightPolicyCheckers: [],
      trainPolicyCheckers: [],
      outOfPolicy: false,
    },
    createdById: 'd649b842-9bff-4a6e-9e52-20f69a082e85',
    createdByType: 'CUSTOMER',
    createdAt: '2021-05-30T00:00:00',
    yourReference: null,
    orderReferenceFields: {
      bookerEmail: '',
      bookerEmployeeNumber: '',
      bookerName: '',
      projectId: '',
      projects: '',
      purposeOfTrip: '',
      purposeOfTripId: '',
      yourReference: '',
    },
  },
};
